// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__EikG-","bigColWidth":"Table_bigColWidth__3ndUV","biggerColWidth":"Table_biggerColWidth__17iWB","row":"Table_row__1R1cx","col":"Table_col__2bO9U"};